module.exports = __webpack_public_path__ + "img/telefonica-logo.3c7468f7.png";